import { emitSessionUrl } from "./events";

const BOOTSTRAP_PARAMS = ["prompt", "mode", "fresh"] as const;

function stripBootstrapParams(url: URL) {
  for (const key of BOOTSTRAP_PARAMS) {
    url.searchParams.delete(key);
  }
}

/** Put sessionId in the address bar without a Next.js navigation (avoids remounting the builder). */
export function syncFlowBuilderSessionUrl(sessionId: string) {
  if (typeof window === "undefined") return;
  const id = sessionId.trim();
  if (!id) return;

  const url = new URL(window.location.href);
  if (!url.pathname.startsWith("/flow-builder")) return;

  const alreadySynced = url.searchParams.get("sessionId") === id;
  const hasBootstrap = BOOTSTRAP_PARAMS.some((key) => url.searchParams.has(key));
  if (alreadySynced && !hasBootstrap) {
    emitSessionUrl(id);
    return;
  }

  url.searchParams.set("sessionId", id);
  stripBootstrapParams(url);
  window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}`);
  emitSessionUrl(id);
}

/** Drop ?sessionId= after the server session is gone (keeps the current page mounted). */
export function clearFlowBuilderSessionUrl() {
  if (typeof window === "undefined") return;
  const url = new URL(window.location.href);
  if (!url.pathname.startsWith("/flow-builder")) return;
  if (!url.searchParams.has("sessionId")) return;
  url.searchParams.delete("sessionId");
  const next = url.search ? `${url.pathname}${url.search}` : url.pathname;
  window.history.replaceState(window.history.state, "", next);
}
